import { render, staticRenderFns } from "./zAguardar.vue?vue&type=template&id=8bd3c25c&scoped=true"
import script from "./zAguardar.vue?vue&type=script&lang=js"
export * from "./zAguardar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd3c25c",
  null
  
)

export default component.exports